import { useEffect, useRef, useState } from "react";
import "./index.scss";
import Api from "../../apis/index";
import { useParams } from "react-router-dom";
import {
  Input,
  message,
  Select,
  Dropdown,
  Avatar,
  Spin,
  Badge,
  Popover,
  Empty,
  Tooltip,
  Typography,
  Modal,
  Button,
  Checkbox,
  Table,
  Tag
} from "antd";
import {
  SearchOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { useDebounce, useUnmount, useSize, useGetState } from "ahooks";
import Scrollbars from "react-custom-scrollbars";
import StatusTag from "../../components/StatusTag";
import { timerInterval } from "../../setting";
import useUrlState from "@ahooksjs/use-url-state";
import ImagesPage from "../ImagesPage";
import ImageDrawer from "../../components/ImageDrawer";
import emptyImg from "../../assets/暂无icon.png";
import logoIcon from "../../assets/logo_white.svg";
import { useNavigate } from "react-router-dom";
import { encryptIdCardAdvanced, getFileName } from "../../unit/unit";
import { Virtuoso } from "react-virtuoso";
import request from "../../apis/request";
const { Paragraph } = Typography;

function TaskDetails() {
  const { id } = useParams();
  const [selectTargetName, setSelectTargetName] = useState("");
  const [selectIdString, setSelectIdString] = useState("");
  const [targetList, setTargetList] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [reportInfo, setReportInfo] = useState({});
  const [followList, setFollowList] = useState([]);
  const [failList, setFailList] = useState([]);
  const debouncedSearchName = useDebounce(searchName, { wait: 200 });

  const [targetType, setTargetType] = useState(1);
  const [naturalPersonList, setNaturalPersonList] = useState([]);
  const [legalPersonList, setLegalPersonList] = useState([]);
  const [searchTargetType, setSearchTargetType] = useState("0");

  const [loading, setLoading] = useState(true);
  const timer = useRef();
  const reportStatusTimer = useRef();
  const [state, setState] = useUrlState({});
  const [downloading, setDownloading] = useState(false);
  const [reportStatus, setReportStatus] = useState(0);
  const [downloadTips, setDownloadTips] = useState({});

  const [downloadList, setDownloadList] = useState([]);
  const [downloadVisible, setDownloadVisible] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [errorList, setErrorList] = useState([]);
  const [errorOpen, setErrorOpen] = useState(false);
  const [retryModalVisible, setRetryModalVisible] = useState(false);

  const [retryLoading, setRetryLoading, getRetryLoading] = useGetState(false);

  const navigate = useNavigate();

  const ref = useRef(null);
  const size = useSize(ref);

  //复制
  const copyLink = (link) => {
    navigator.clipboard.writeText(link).then(
      () => {
        message.success("链接已复制到剪贴板");
      },
      () => {
        message.error("复制失败，请手动复制");
      },
    );
  };

  const columnsRef = useRef([
    {
      title: "序号",
      dataIndex: "index",
      align: "center",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: "网站",
      dataIndex: "title",
      key: "title",
      align: "center",
      render: (text, record) => {
        return (
          <div style={{ width: "100%", display: "flex" }}>
            <a
              href={record.url}
              target="_blank"
              title={record.url}
              style={{
                color: "#006AB2",
                textDecoration: "underline",
                textAlign: "left",
              }}
            >
              {text}
            </a>
          </div>
        );
      },
    },
    {
      title: "操作",
      dataIndex: "url",
      align: "center",
      width: 120,
      render: (_, record, index) => (
        <span
          style={{ color: "#006abe", cursor: "pointer" }}
          onClick={() => copyLink(record.url)}
        >
          复制链接
        </span>
      ),
    },
  ]);

  useUnmount(() => {
    clearTimeout(timer.current);
    clearTimeout(reportStatusTimer.current);
  });

  //获取核查对象列表
  const getTaskObjectsList = () => {
    Api.getTaskObjectsList(id).then((res) => {
      if (res.code === 200) {
        const list = res.data.map((_) => {
          _.idString =
            _.target_name +
            "~~$~~" +
            (_.company || "") +
            "~~$~~" +
            (_.id_card || "") +
            "~~$~~" +
            (_.area || "");
          return _;
        });
        setTargetList(list);
        let a = [],
          b = [];
        list.forEach((_) => {
          if (_.check_type === 1) {
            a.push(_);
          } else {
            b.push(_);
          }
        });
        setLegalPersonList(a);
        setNaturalPersonList(b);
        if (a.length > 0) {
          setTargetType(1);
          setSelectTargetName(a.at(0)?.target_name);
          setSelectIdString(a.at(0)?.idString || "");
        } else {
          setTargetType(2);
          let item = b.at(0);
          setSelectTargetName(item?.target_name);
          setSelectIdString(item?.idString || "");
        }
      } else {
        message.error(res.message);
        if (res.code === -1) {
          navigate("/home");
        }
      }
    });
  };

  //更新核查对象列表
  const updataTaskObjectsList = () => {
    Api.getTaskObjectsList(id).then((res) => {
      if (res.code === 200) {
        const list = res.data.map((_) => {
          _.idString =
            _.target_name +
            "~~$~~" +
            (_.company || "") +
            "~~$~~" +
            (_.id_card || "") +
            "~~$~~" +
            (_.area || "");
          return _;
        });
        setTargetList(list);
        let a = [],
          b = [];
        list.forEach((_) => {
          if (_.check_type === 1) {
            a.push(_);
          } else {
            b.push(_);
          }
        });
        setLegalPersonList(a);
        setNaturalPersonList(b);
      } else {
        message.error(res.message);
      }
    });
  };

  //重试报告生成
  const retryReportStatus = () => {
    Api.retryReportStatus(id).then((res) => {
      if (res.code === 200) {
        setTimeout(() => {
          getReportStatus();
        }, 1000);
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  //获取报告状态
  const getReportStatus = () => {
    if (reportStatusTimer.current) {
      clearTimeout(reportStatusTimer.current);
      reportStatusTimer.current = null;
    }
    //获取报告状态
    Api.getReportStatus(id).then((res) => {
      console.log(res, "--------报告状态");
      if (res.code === 200) {
        setReportStatus(res.data);
        if (res.data === 1) {
          reportStatusTimer.current = setTimeout(() => {
            getReportStatus();
          }, timerInterval);
        }
      } else {
        message.error(res.message);
        setReportStatus(0);
      }
    });
  };

  //获取核查详情
  const getTaskInfo = (selectIdString, notLoading) => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    if (!notLoading) {
      setLoading(true);
    }
    const [targetName, company, id_card, area] = selectIdString.split("~~$~~");
    Api.getTaskInfo(id, targetName, company, id_card, area).then((res) => {
      let followList = [],
        failList = [];
      if (res.code === 200) {
        setReportInfo(res.data);
        res.data.data.forEach((item) => {
          item.list.forEach((_) => {
            if (_.check_res === 2) {
              followList.push(_);
            }
            if (_.check_res === 50) {
              failList.push(_);
            }
          });
        });
        setFollowList(followList);
        setFailList(failList);
        updataTaskObjectsList();
      } else {
        message.error(res.message);
      }
      //0:未开始. 10:排队中.  20:核查中.  30:已完成.  40:已终止.  50:失败
      if ([0, 10, 20].includes(res?.data?.info_dic?.status)) {
        timer.current = setTimeout(() => {
          getTaskInfo(selectIdString, true);
        }, timerInterval);
      }
      setLoading(false);
    });

    getReportStatus();
  };

  //下载报告
  const downloadReport = (type) => {
    let params = {
      check_id: id,
    };
    setDownloading(true);
    setSelectedFiles([]);
    Api.downloadReport(params)
      .then((res) => {
        console.log(res);
        if (res.code === 200) {
          setDownloadVisible(true);
          setDownloadList(res.data);
        } else {
          setDownloadList([]);
          message.error(res.message);
        }
        setDownloading(false);
      })
      .catch(() => {
        setDownloading(false);
      });

    Api.getDownloadTips(params).then((res) => {
      console.log(res);
      if (res.code === 200) {
        setDownloadTips(res.data);
      } else {
        setDownloadTips({});
      }
    });
  };

  //下载单个报告文件（直接浏览器下载）
  const downloadFile = (path) => {
    const url = `${request.defaults.baseURL || ""}/report/download?file_path=${encodeURIComponent(path)}&task_id=${id}`;
    const iframe = document.createElement("iframe");
    iframe.src = url;
    iframe.style.display = "none";
    iframe.name = `download_iframe_${Date.now()}_${Math.random()}`;
    iframe.onload = () => {
      setTimeout(() => document.body.removeChild(iframe), 5000);
    };
    document.body.appendChild(iframe);
  };

  //全部下载
  const downloadAllFiles = () => {
    downloadList.forEach((path, index) => {
      setTimeout(() => {
        downloadFile(path);
      }, index * 50);
    });
  };

  //下载选中文件
  const downloadSelectedFiles = () => {
    if (selectedFiles.length === 0) {
      message.warning("请先勾选要下载的文件");
      return;
    }
    selectedFiles.forEach((path, index) => {
      setTimeout(() => {
        downloadFile(path);
      }, index * 50);
    });
  };

  //切换单个文件选中状态
  const toggleFileSelection = (path) => {
    setSelectedFiles((prev) => {
      if (prev.includes(path)) {
        return prev.filter((p) => p !== path);
      } else {
        return [...prev, path];
      }
    });
  };

  //切换全选状态
  const toggleSelectAll = () => {
    if (selectedFiles.length === downloadList.length) {
      setSelectedFiles([]);
    } else {
      setSelectedFiles([...downloadList]);
    }
  };

  //查看截图
  const toImgPage = (info, type) => {
    const [targetName, company, id_card, area] = selectIdString.split("~~$~~");
    // type: 1-检索截图 2-详情截图/附件
    window.open(
      window.location.origin +
        window.location.pathname +
        `?q=${window.btoa(
          window.encodeURIComponent(
            JSON.stringify({
              companyName: targetName,
              company: company,
              idCard: id_card,
              area: area,
              originCompanyName: info?.origin_name,
              type,
              web_id: info.web_id,
            }),
          ),
        )}`,
      selectTargetName + "-" + id,
    );
  };

  //处理点击事件
  const handleItem = (type, item) => {
    if (type === "重试") {
      if (getRetryLoading()) {
        return;
      }
      setRetryLoading(true);
      Api.retryVerification(id, item.crawler_id)
        .then((res) => {
          if (res.code === 200) {
            message.success(res.message);
            getTaskInfo(selectIdString, true);
          } else {
            message.error(res.message);
          }
          setRetryLoading(false);
        })
        .catch(() => {
          setRetryLoading(false);
        });
    }
    if (type === "手工核查-检索截图" || type === "手工核查-详情截图/附件") {
      let params = {
        companyName: item.target_name,
        company: item.company,
        id_card: item.id_card,
        area: item.area,
        task_id: id,
        web_id: item.web_id,
        type: type === "手工核查-检索截图" ? 1 : 2,
      };

      ImageDrawer({
        title: type,
        ...params,
        onOk: () => {
          getTaskInfo(selectIdString, true);
        },
      });
    }
    if (type === "详情") {
      let list = item.error_detail || [];
      setErrorList(list);
      setTimeout(() => {
        setErrorOpen(true);
      }, 50);
    }
  };

  //全部重试按钮点击
  const handleRetryAllClick = () => {
    setRetryModalVisible(true);
  };

  //全部重试
  const handleRetryAll = (isCurrent) => {
    if (getRetryLoading()) {
      return;
    }
    setRetryLoading(true);
    let params = {};
    if (isCurrent) {
      const [targetName, company, id_card, area] =
        selectIdString.split("~~$~~");

      params.target_name = targetName;
      params.company = company;
      params.id_card = id_card;
      params.area = area;
    }
    Api.retryAllVerification(id, params)
      .then((res) => {
        if (res.code === 200) {
          message.success(res.message);
          setRetryModalVisible(false);
          getTaskInfo(selectIdString, true);
        } else {
          message.error(res.message);
        }
        setRetryLoading(false);
      })
      .catch(() => {
        setRetryLoading(false);
      });
  };

  //初始化表格
  const initTableDom = (list, isObject) => {
    let columns = [
      {
        title: "核查网站",
        dataIndex: "web_name",
        key: "web_name",
        width: "30%",
        render: (text, record) => {
          return (
            <span
              className="webNameSpan"
              onClick={() => {
                window.open(record.url || "javascript:;");
              }}
            >
              <span
                className="webNameSpanIcon"
                style={{ backgroundColor: record.web_color || "#0068B2" }}
              >
                {
                  <img
                    src={record.web_icon || logoIcon}
                    alt={record.web_name}
                    style={{
                      width: "14px",
                      height: "14px",
                    }}
                  />
                }
              </span>
              <Paragraph
                style={{ maxWidth: `calc(100% - ${28}px)`, marginBottom: "0" }}
                ellipsis={{
                  tooltip: text,

                  rows: 1,
                }}
              >
                <span className="webNameSpanText"> {text}</span>
              </Paragraph>
            </span>
          );
        },
      },
      {
        title: "核查结果",
        dataIndex: "check_res_name",
        key: "check_res_name",
        width: "35%",
        render: (text, record) => (
          <div className="checkResBox">
            <StatusTag
              isTag={true}
              data={{
                status: record.check_res,
                status_name: record.check_res_name,
              }}
            ></StatusTag>
            {/* 正常但是截图缺失 */}
            {record.check_res === 1 &&
            (record?.error_detail || [])?.length > 0 ? (
              <span>
                {record?.failed_reason}
                {(record?.error_detail || [])?.length > 0 ? (
                  <span
                    className="btnSpan"
                    onClick={() => {
                      handleItem("详情", record);
                    }}
                  >
                    详情
                  </span>
                ) : null}
              </span>
            ) : null}
            {record.check_res === 50 && (
              <span>
                {record?.failed_reason}
                <span
                  className="btnSpan"
                  onClick={() => {
                    handleItem("重试", record);
                  }}
                >
                  重试
                </span>
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: "检索截图",
                        label: <span>检索截图</span>,
                      },
                      {
                        key: "详情截图/附件",
                        label: <span>详情截图/附件</span>,
                      },
                    ],
                    onClick: ({ key }) => {
                      handleItem(`手工核查-${key}`, record);
                    },
                  }}
                >
                  <span className="btnSpan">手工核查</span>
                </Dropdown>
              </span>
            )}
          </div>
        ),
      },
      {
        title: "检索截图",
        dataIndex: "search_count",
        key: "search_count",
        width: "15%",
        render: (text, record) => (
          <span
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {record?.search_count ? (
              <span
                className="pathSpan"
                onClick={() => {
                  toImgPage(record, 1);
                }}
              >
                查看（{record?.search_count || 0}）
              </span>
            ) : (
              "-"
            )}
          </span>
        ),
      },
      {
        title: "详情截图/附件",
        dataIndex: "detail_count",
        key: "detail_count",
        width: "20%",
        render: (text, record) => (
          <span>
            {record?.detail_count ? (
              <>
                共{record?.detail_count || 0}条信息
                <span
                  className="pathSpan"
                  style={{ marginLeft: "4px" }}
                  onClick={() => {
                    toImgPage(record, 2);
                  }}
                >
                  查看
                </span>
              </>
            ) : (
              "-"
            )}
            {record?.detail_wudao_count ? <br></br> : null}

            {record?.detail_wudao_count ? (
              <>
                吾道补充{record?.detail_wudao_count || 0}条信息
                <span
                  className="pathSpan"
                  style={{ marginLeft: "4px" }}
                  onClick={() => {
                    toImgPage(record, 4);
                  }}
                >
                  查看
                </span>
              </>
            ) : null}
          </span>
        ),
      },
    ];
    let arr = [];
    if (isObject) {
      list = list.sort((a, b) => a.seq - b.seq);
      list.forEach((item) => {
        arr.push({ web_type: item.web_type, type: "type" });
        item.list.forEach((_) => {
          arr.push({ ..._ });
        });
      });
    } else {
      arr = list.map((_, index) => ({ ..._, idx: index }));
    }
    return (
      <div className="taskDetailsTableContent">
        <div className="tableHeader">
          {columns.map((col) => (
            <div
              className="tableHeaderItem"
              key={col.key}
              style={{ width: `calc(${col.width} - 2px)` }}
            >
              {col.title}
            </div>
          ))}
        </div>
        <div className="tableBody">
          {arr.map((item, index) => (
            <div
              className={`tableBodyRow ${
                index % 2 !== 0 ? "tableBodyUnBorderRow" : ""
              }`}
              key={index}
            >
              {columns.map((col, idx) => (
                <div
                  className="tableBodyItem"
                  key={col.key}
                  style={{ width: `calc(${col.width} - 2px)` }}
                >
                  {item.type === "type" ? (
                    idx === 0 ? (
                      <b>{item.web_type}</b>
                    ) : null
                  ) : col.render ? (
                    col.render(item[col.dataIndex], item)
                  ) : (
                    item[col.dataIndex]
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  };

  //监听选中对象变化
  useEffect(() => {
    if (!selectIdString) {
      return;
    }
    getTaskInfo(selectIdString);
  }, [selectIdString]);

  //监听搜索名称变化
  useEffect(() => {
    const list = targetList.filter((item) => {
      if (item.target_name.includes(debouncedSearchName)) {
        return true;
      }
      if (item.origin_name && item.origin_name?.includes(debouncedSearchName)) {
        return true;
      }
      if (item.company && item.company?.includes(debouncedSearchName)) {
        return true;
      }
      if (item.id_card && item.id_card?.includes(debouncedSearchName)) {
        return true;
      }
      if (item.area && item.area?.includes(debouncedSearchName)) {
        return true;
      }
      return false;
    });
    let a = [],
      b = [];
    list.forEach((_) => {
      if (_.check_type === 1) {
        a.push(_);
      } else {
        b.push(_);
      }
    });
    setLegalPersonList(a);
    setNaturalPersonList(b);
  }, [debouncedSearchName]);

  //监听搜索对象类型变化
  useEffect(() => {
    const list = targetList.filter((item) => {
      if (searchTargetType === "0") {
        return true;
      } else if (searchTargetType === "1") {
        return item.abnormal_count > 0;
      } else if (searchTargetType === "2") {
        return item.failed_count > 0;
      }
      return true;
    });
    let a = [],
      b = [];
    list.forEach((_) => {
      if (_.check_type === 1) {
        a.push(_);
      } else {
        b.push(_);
      }
    });
    setLegalPersonList(a);
    setNaturalPersonList(b);
  }, [searchTargetType]);

  //初始化
  useEffect(() => {
    if (state.q) {
      return;
    }
    getTaskObjectsList();
  }, []);

  return (
    <Spin tip="加载中..." spinning={loading} wrapperClassName="taskDetailsSpin">
      {state.q ? (
        <ImagesPage setLoading={setLoading}></ImagesPage>
      ) : (
        <div className="taskDetails">
          <div className="targetListBox" ref={ref}>
            <div className="targetListBoxHeader">
              <Input
                className="targetListBoxSearchInput"
                placeholder="输入名称搜索"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                suffix={<SearchOutlined />}
              ></Input>

              <div className="tabsBox">
                <span className="tabs">
                  <span
                    className={`tabItem ${targetType === 1 ? "active" : ""}`}
                    onClick={() => setTargetType(1)}
                  >
                    法人({legalPersonList.length})
                  </span>
                  <div
                    className={`tabItem ${targetType === 2 ? "active" : ""}`}
                    onClick={() => setTargetType(2)}
                    style={{ width: "88px" }}
                  >
                    自然人({naturalPersonList.length})
                  </div>
                </span>
                <Select
                  variant="borderless"
                  style={{ maxWidth: "100px", color: "#fff" }}
                  value={searchTargetType}
                  onChange={(value) => setSearchTargetType(value)}
                  popupMatchSelectWidth={false}
                  options={[
                    { value: "0", label: "全部" },
                    { value: "1", label: "需关注" },
                    { value: "2", label: "核查失败" },
                  ]}
                />
              </div>
            </div>

            <div>
              {/* <List
                bordered={false}
                dataSource={
                  targetType === 1 ? legalPersonList : naturalPersonList
                }
                locale={{
                  emptyText: (
                    <Empty image={emptyImg} description="暂无数据"></Empty>
                  ),
                }}
                renderItem={(item) => (
                  <List.Item
                    className={
                      item.target_name === selectTargetName
                        ? "listItem activeListItem"
                        : "listItem"
                    }
                    onClick={() => setSelectTargetName(item.target_name)}
                  >
                    <Badge
                      count={
                        <Tooltip
                          placement="topLeft"
                          title={`异常结果${
                            (item.failed_count || 0) +
                            (item.abnormal_count || 0)
                          }个`}
                        >
                          <Badge
                            size="small"
                            count={
                              (item.failed_count || 0) +
                              (item.abnormal_count || 0)
                            }
                            style={{ left: "10px" }}
                          />
                        </Tooltip>
                      }
                      size="small"
                      // offset={[20, 0]}
                    >
                      <span>{item.target_name}</span>
                    </Badge>
                  </List.Item>
                )}
              /> */}
              {(targetType === 1 ? legalPersonList : naturalPersonList)
                .length === 0 ? (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "80px",
                  }}
                >
                  <Empty image={emptyImg} description="暂无数据"></Empty>
                </div>
              ) : (
                <Virtuoso
                  style={{ height: (size?.height - 120 || 400) + "px" }}
                  totalCount={
                    (targetType === 1 ? legalPersonList : naturalPersonList)
                      .length
                  }
                  itemContent={(index) => {
                    const item = (
                      targetType === 1 ? legalPersonList : naturalPersonList
                    )[index];
                    return (
                      <Tooltip
                        placement="right"
                        title={
                          item.check_type === 1 ? (
                            <div className="targetNameTooltipDiv">
                              <div>{item.target_name}</div>
                              {item.origin_name === item.target_name ? null : (
                                <div>
                                  <span className="targetNameTooltipTitleSpan">
                                    现用名:{" "}
                                  </span>
                                  <span>{item.origin_name}</span>
                                </div>
                              )}
                              {item.area && (
                                <div>
                                  <span className="targetNameTooltipTitleSpan">
                                    地区:{" "}
                                  </span>
                                  <span>{item.area}</span>
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className="targetNameTooltipDiv">
                              <div>{item.target_name}</div>
                              {item.company && (
                                <div>
                                  <span className="targetNameTooltipTitleSpan">
                                    企业名称:{" "}
                                  </span>
                                  <span>{item.company}</span>
                                </div>
                              )}
                              {item.id_card && (
                                <div>
                                  <span className="targetNameTooltipTitleSpan">
                                    身份证号:{" "}
                                  </span>
                                  <span>
                                    {encryptIdCardAdvanced(item.id_card, {
                                      keepStart: 4,
                                    })}
                                  </span>
                                </div>
                              )}
                              {item.area && (
                                <div>
                                  <span className="targetNameTooltipTitleSpan">
                                    地区:{" "}
                                  </span>
                                  <span>{item.area}</span>
                                </div>
                              )}
                            </div>
                          )
                        }
                        style={{ width: "100%" }}
                      >
                        <div
                          className={
                            item.idString === selectIdString
                              ? "listItem activeListItem"
                              : "listItem"
                          }
                          onClick={() => {
                            setSelectTargetName(item.target_name);
                            setSelectIdString(item.idString);
                          }}
                        >
                          <Badge
                            count={
                              <Tooltip
                                placement="topLeft"
                                title={`异常结果${
                                  (item.failed_count || 0) +
                                  (item.abnormal_count || 0)
                                }个`}
                              >
                                <Badge
                                  size="small"
                                  count={
                                    (item.failed_count || 0) +
                                    (item.abnormal_count || 0)
                                  }
                                  style={{
                                    left: "6px",
                                    top: "2px",
                                    padding: "0 4px",
                                  }}
                                />
                              </Tooltip>
                            }
                            size="small"
                            // offset={[20, 0]}
                          >
                            <Paragraph
                              style={{
                                maxWidth: "100%",
                                marginBottom: "0",
                              }}
                              ellipsis={{
                                tooltip: false,
                                rows: 1,
                              }}
                            >
                              {item.target_name}
                              {item.check_type === 2
                                ? item.company || item.id_card
                                  ? `（${item.company || ""}${
                                      item.company && item.id_card ? " " : ""
                                    }${
                                      item.id_card
                                        ? encryptIdCardAdvanced(item.id_card, {
                                            keepStart: 4,
                                          })
                                        : ""
                                    }）`
                                  : ""
                                : item.origin_name === item.target_name
                                  ? ""
                                  : `（曾用名）`}
                            </Paragraph>
                          </Badge>
                        </div>
                      </Tooltip>
                    );
                  }}
                />
              )}
            </div>
          </div>
          <Scrollbars
            autoHide={true}
            autoHideTimeout={5000}
            style={{ height: "100%", width: "1000px" }}
          >
            <div className="taskDetailsBox">
              <div className="taskDetailsContentHeader">
                核查报告
                {reportStatus ? (
                  reportStatus === 1 || reportStatus === 3 ? (
                    <Tooltip
                      title={
                        reportStatus === 1
                          ? "报告生成中，请稍后下载"
                          : "报告生成失败，请点击重试"
                      }
                    >
                      <span
                        className="downloadReportSpan"
                        onClick={() => {
                          if (reportStatus === 1) {
                            return;
                          }
                          retryReportStatus();
                        }}
                      >
                        下载报告
                        {reportStatus === 3 ? (
                          <SyncOutlined
                            style={{ marginLeft: "4px", cursor: "pointer" }}
                          />
                        ) : null}
                      </span>
                    </Tooltip>
                  ) : downloading ? (
                    <span className="downloadReportSpan">
                      下载中
                      <LoadingOutlined style={{ marginLeft: "4px" }} />
                    </span>
                  ) : (
                    // <Dropdown
                    //   menu={{
                    //     items: [
                    //       {
                    //         key: "word",
                    //         label: (
                    //           <span
                    //             className="wordReportSpan"
                    //             onClick={() => {
                    //               downloadReport("word");
                    //             }}
                    //           >
                    //             <svg
                    //               t="1757485583111"
                    //               viewBox="0 0 1024 1024"
                    //               version="1.1"
                    //               p-id="2430"
                    //               width="16"
                    //               height="16"
                    //             >
                    //               <path
                    //                 d="M535.119473 0h69.599248v95.247413C729.226717 96.331138 853.614299 93.92286 977.881468 96.331138a40.459078 40.459078 0 0 1 44.914393 45.516463c2.047037 234.566322 0 469.614299 1.204139 703.819379-1.204139 24.082785 2.287865 50.694262-11.318909 72.248354-16.978363 12.041392-38.893697 10.837253-58.761994 12.041392h-349.200376V1023.518344h-72.248354C354.980245 990.886171 177.490122 960.541863 0 928.752587V95.488241C178.33302 63.578551 356.786453 32.511759 535.119473 0z"
                    //                 fill="#2A5699"
                    //                 p-id="2431"
                    //               ></path>
                    //               <path
                    //                 d="M604.718721 131.010348H988.598307v761.979304H604.718721v-95.247413h302.479774v-48.165569H604.718721v-59.002822h302.479774v-48.16557H604.718721v-59.002822h302.479774v-48.165569H604.718721v-60.206961h302.479774V428.673565H604.718721v-60.206961h302.479774v-46.96143H604.718721v-59.604892h302.479774V214.336783H604.718721zM240.827846 341.373471c22.156162-1.324553 44.19191-2.287865 66.348071-3.492003 15.533396 80.4365 31.30762 160.632173 48.165569 240.827845 13.125118-82.724365 27.695202-165.087488 41.783632-247.571025 23.239887-0.842897 46.479774-2.167451 69.719661-3.612418-26.370649 115.356538-49.369708 231.796802-78.148636 346.430856-19.386642 10.355597-48.165569 0-71.52587 1.204139C301.034807 596.169332 283.093133 517.779868 269.245532 438.667921c-13.606773 76.944497-31.30762 153.16651-46.841016 229.508937-22.39699-1.204139-44.793979-2.528692-67.311383-4.094073-19.266228-104.760113-42.024459-208.918156-60.206962-313.919097 19.868297-0.963311 39.857008-1.806209 60.206962-2.528693 12.041392 75.860771 25.648166 151.360301 36.124177 227.341487 16.135466-77.907808 32.873001-155.695202 49.610536-233.603011z"
                    //                 fill="#FFFFFF"
                    //                 p-id="2432"
                    //               ></path>
                    //             </svg>
                    //             Word报告（含截图）
                    //           </span>
                    //         ),
                    //       },
                    //       {
                    //         key: "pdf",
                    //         label: (
                    //           <span
                    //             className="wordReportSpan"
                    //             onClick={() => {
                    //               downloadReport("pdf");
                    //             }}
                    //           >
                    //             <svg
                    //               t="1757485668129"
                    //               viewBox="0 0 1024 1024"
                    //               version="1.1"
                    //               p-id="4447"
                    //               width="16"
                    //               height="16"
                    //             >
                    //               <path
                    //                 d="M535.198324 0h69.53853v95.276816c124.175945 0.677323 248.351891-1.354647 373.205159 0.677324a40.6394 40.6394 0 0 1 45.154889 45.154889c1.919083 234.579649 0 469.272186 1.128872 703.851835-1.128872 24.044979 2.257744 50.686363-11.288722 72.022049-17.045971 12.417595-38.946092 11.288722-58.814243 11.288722H604.962628v95.276816h-72.925146C354.917429 990.924044 177.458715 960.557381 0 928.723184V95.502591C178.361812 63.555507 356.836512 32.51152 535.198324 0z"
                    //                 fill="#A33639"
                    //                 p-id="4448"
                    //               ></path>
                    //               <path
                    //                 d="M604.736854 130.949179h383.816558v762.101642h-383.816558v-95.276816h302.42487v-47.638408H604.736854v-59.491567h302.42487V643.457171H604.736854v-60.056002h302.42487v-47.638409H604.736854v-59.491566h302.42487V428.971447H604.736854v-59.830228h302.42487v-47.638408H604.736854V261.898357h302.42487v597.17341H604.736854z"
                    //                 fill="#FFFFFF"
                    //                 p-id="4449"
                    //               ></path>
                    //               <path
                    //                 d="M645.489141 529.66685h302.424871v47.638409H645.489141zM645.489141 611.510087h302.424871v47.638408H645.489141zM645.489141 693.353324h302.424871v47.638408H645.489141zM596.383199 775.19656h351.530813v47.638409H596.383199z"
                    //                 fill="#A33639"
                    //                 p-id="4450"
                    //               ></path>
                    //               <path
                    //                 d="M180.619557 317.325984c59.265792 2.822181 130.949179-24.044979 180.619557 21.335685 46.961085 58.475582 34.54349 165.831331-35.107927 200.713483-24.722302 12.982031-53.169882 11.288722-80.037041 10.272737v130.949179L180.619557 675.065594c-0.903098-119.208908-1.128872-238.530702 0-357.73961z"
                    //                 fill="#FFFFFF"
                    //                 p-id="4451"
                    //               ></path>
                    //               <path
                    //                 d="M245.642597 377.720648c21.448572-1.015985 48.089957-5.079925 62.539522 15.578437a82.407673 82.407673 0 0 1 1.467534 73.263808c-12.417595 22.577445-40.526513 20.771249-62.313747 23.367655-2.257744-37.365671-2.03197-74.731342-1.693309-112.2099zM885.713152 379.865505a83.988094 83.988094 0 0 1-48.315732-19.642376 460.57987 460.57987 0 0 0-77.666409 24.835189c-20.3197 36.011024-39.171866 54.411641-55.540514 54.411641a17.384632 17.384632 0 0 1-9.821188-2.596406 19.416602 19.416602 0 0 1-11.288723-17.723294c0-5.870136 1.354647-22.577445 63.329733-49.105942a467.917539 467.917539 0 0 0 34.656377-81.278801c-7.902106-15.691324-24.835189-54.298754-13.094918-73.941131a20.658362 20.658362 0 0 1 20.206813-10.498511 21.900121 21.900121 0 0 1 17.045971 8.466541c8.466542 11.288722 7.789218 36.688347-3.27373 73.376695A196.988204 196.988204 0 0 0 842.70312 338.661669a221.14607 221.14607 0 0 1 41.090949-4.515489c30.705325 0.677323 35.333701 15.014001 34.656377 23.59343 0 22.577445-21.56146 22.577445-32.624407 22.577444z m-185.022159 42.106935l2.257745-0.564436a45.154889 45.154889 0 0 0 23.932091-16.820197 56.443612 56.443612 0 0 0-26.189836 17.384633z m93.357734-200.261934h-2.144858a4.402602 4.402602 0 0 0-2.82218 0.677323 52.492559 52.492559 0 0 0 4.176827 33.866167 53.282769 53.282769 0 0 0 0.790211-34.54349zM790.210561 317.551758v1.24176l-0.677323-0.677324c-5.418587 14.336677-11.288722 28.44758-18.061956 42.332709l1.128872-0.677323V361.239114A346.338 346.338 0 0 1 812.788006 348.595745l-0.677324-0.564436h1.806196a196.310881 196.310881 0 0 1-23.706317-30.479551z m94.599493 34.769265a66.151913 66.151913 0 0 0-18.174843 1.693308 50.686363 50.686363 0 0 0 20.997024 6.660347 26.076949 26.076949 0 0 0 13.885128-1.580422c-0.451549-2.596406-3.273729-6.773233-17.158858-6.773233z"
                    //                 fill="#A33639"
                    //                 p-id="4452"
                    //               ></path>
                    //             </svg>
                    //             PDF报告（含截图）
                    //           </span>
                    //         ),
                    //       },
                    //     ],
                    //   }}
                    //   placement="bottomRight"
                    // >
                    //   <span className="downloadReportSpan">下载报告</span>
                    // </Dropdown>
                    <span
                      className="downloadReportSpan"
                      onClick={() => {
                        downloadReport();
                      }}
                    >
                      下载报告
                    </span>
                  )
                ) : null}
                {reportInfo.info_dic?.status === 40 && !reportStatus ? (
                  <span
                    className="downloadReportSpan"
                    onClick={() => {
                      retryReportStatus();
                    }}
                  >
                    重新生成报告
                  </span>
                ) : null}
              </div>
              <div className="taskDetailsUserInfoBox">
                <div className="taskDetailsUserInfoItem">
                  <span>{reportInfo.info_dic?.create_time}</span>
                  <span>
                    <Avatar
                      size={20}
                      src={reportInfo.info_dic?.pf_photo}
                      style={{ marginRight: "4px" }}
                    />
                    {reportInfo.info_dic?.show_name}
                  </span>
                  <span>
                    <StatusTag data={reportInfo?.info_dic || {}}></StatusTag>
                  </span>
                </div>
                <div className="taskDetailsSettingInfoItem">
                  <div>
                    核查网站数<span>{reportInfo.info_dic?.web_count}</span>
                  </div>
                  <Popover
                    rootClassName="checkSettingPopover"
                    content={
                      <div className="checkSettingPopoverContent">
                        <div>
                          <i></i>水印：
                          {[
                            { label: "网站核查", key: "website_verification" },
                            {
                              label: "核查对象",
                              key: "object_of_verification",
                            },
                            { label: "核查时间", key: "verification_time" },
                            {
                              label: "电脑系统时间",
                              key: "verification_system_time",
                            },
                            { label: "核查人", key: "verifier" },
                          ]
                            .reduce((acc, cur) => {
                              if (
                                reportInfo.info_dic?.check_settings
                                  ?.watermark_config?.[cur.key]
                              ) {
                                acc.push(
                                  cur.label === "核查人"
                                    ? `${cur.label}"${
                                        reportInfo.info_dic?.check_settings
                                          ?.watermark_config?.[cur.key]
                                      }"`
                                    : cur.label,
                                );
                              }
                              return acc;
                            }, [])
                            .join("、") || "无"}
                        </div>
                        <div>
                          <i></i>是否核查曾用名：
                          {reportInfo.info_dic?.check_settings
                            ?.check_former_name === 1
                            ? "是"
                            : "否"}
                        </div>
                        <div>
                          <i></i>报告中如何展示截图：
                          {reportInfo.info_dic?.check_settings
                            ?.report_screenshot_display_type === 1
                            ? "直接插入图片"
                            : "仅插入图片链接"}
                        </div>
                        {/* <div>
                          <i></i>是否自动补充吾道数据库已有数据：
                          {reportInfo.info_dic?.check_settings
                            ?.auto_fillcheck_wudao_data === 1
                            ? "是"
                            : "否"}
                        </div> */}
                      </div>
                    }
                    placement="bottomRight"
                  >
                    <div>
                      核查设置
                      <InfoCircleOutlined />
                    </div>
                  </Popover>
                </div>
              </div>
              {(followList.length > 0 || failList.length > 0) && (
                <div className="taskDetailsAbnormalContent">
                  <span className="abnormalContentTitle">
                    异常结果
                    <span className="abnormalContentTitleCount">
                      <Tag className="abnormalContentTitleCountNumber">{(followList.length || 0) + (failList.length || 0)}</Tag>
                      <span className="abnormalContentTitleCountText"> = {followList.length > 0 ? `需关注 ${followList.length}` : null} {followList.length > 0 && failList.length > 0 ? `+` : null} {failList.length > 0 ? `核查失败 ${failList.length}` : null}</span>
                    </span>
                  </span>
                  {followList.length > 0 && (
                    <div className="abnormalContentTitleBox">
                      <span>{followList.length}</span>
                      个网站发现关注项
                    </div>
                  )}
                  {followList.length > 0 && initTableDom(followList)}
                  {failList.length > 0 && (
                    <div
                      className="abnormalContentTitleBox"
                      style={{
                        color: "#FEC054",
                        background: "rgba(254,192,84,0.15)",
                      }}
                    >
                      <span style={{ background: "#FEC054" }}>
                        {failList.length}
                      </span>
                      个网站发现核查失败
                      {failList.length > 0 &&
                        (reportInfo?.info_dic?.status === 30 ||
                          reportInfo?.info_dic?.status === 50) && (
                          <i
                            className="downloadReportSpan"
                            onClick={() => {
                              handleRetryAllClick();
                            }}
                          >
                            全部重试
                          </i>
                        )}
                    </div>
                  )}
                  {failList.length > 0 && initTableDom(failList)}
                </div>
              )}
              <div className="taskDetailsResultContent">
                <span
                  className="resultContentTitle"
                  style={{ color: "#000000", marginTop: "20px" }}
                >
                  全部核查结果
                </span>
                {initTableDom(reportInfo.data || [], true)}
              </div>
            </div>
          </Scrollbars>
        </div>
      )}
      <Modal
        title={
          <div className="downloadModalTitle">
            <Checkbox
              indeterminate={
                selectedFiles.length > 0 &&
                selectedFiles.length < downloadList.length
              }
              checked={
                downloadList.length > 0 &&
                selectedFiles.length === downloadList.length
              }
              onChange={toggleSelectAll}
            >
              <span className="downloadModalTitleText">报告列表</span>
            </Checkbox>
            <div className="downloadModalActions">
              <Button type="primary" onClick={downloadAllFiles}>
                全部下载
              </Button>
              <Button type="primary" onClick={downloadSelectedFiles}>
                下载
              </Button>
            </div>
          </div>
        }
        open={downloadVisible}
        width={800}
        centered
        className="downloadVModal"
        footer={null}
        onCancel={() => setDownloadVisible(false)}
      >
        <div className="downloadModalBody">
          {downloadList.map((path) => (
            <div key={path} className="downloadModalItem">
              <Checkbox
                checked={selectedFiles.includes(path)}
                onChange={(e) => {
                  toggleFileSelection(path);
                  e.stopPropagation();
                }}
              />
              <Tooltip
                placement="top"
                overlayStyle={{ maxWidth: "700px" }}
                title={
                  <div style={{ fontSize: "10px" }}>
                    {(downloadTips || {})[path]}
                  </div>
                }
              >
                <span
                  className="downloadModalItemName"
                  title={getFileName(path)}
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    toggleFileSelection(path);
                    e.stopPropagation();
                  }}
                >
                  {getFileName(path)}
                </span>
              </Tooltip>
            </div>
          ))}
        </div>
      </Modal>

      <Modal
        title="截图失败网页"
        open={errorOpen}
        width={1000}
        centered
        className="downloadVModal2"
        footer={
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button onClick={() => setErrorOpen(false)}>关闭</Button>
          </div>
        }
        onCancel={() => setErrorOpen(false)}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <Table
            className="errorListTable"
            bordered={true}
            pagination={false}
            dataSource={errorList}
            columns={columnsRef.current}
          ></Table>
        </div>
      </Modal>

      <Modal
        title={"全部重试"}
        visible={retryModalVisible}
        onCancel={() => {
          setRetryModalVisible(false);
        }}
        //   onOk={handleOk}
        wrapClassName="retryModal"
        width={500}
        centered
        footer={null}
        zIndex={2001}
      >
        <div className="messageModalContent" style={{ display: "flex" }}>
          <div className="descriptionBox">
            <div
              style={{
                height: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              重试核查失败的网站？
            </div>
          </div>

          <div className="drawerFooterBtnBox btnBox">
            <Button
              className="noBg btn"
              onClick={() => {
                setRetryModalVisible(false);
              }}
            >
              取消
            </Button>
            <Button
              className="btn"
              type="primary"
              onClick={() => {
                handleRetryAll(true);
              }}
            >
              <div className="btnTip">（仅当前核查对象）</div>
              重试
            </Button>
            <Button
              className="btn"
              type="primary"
              onClick={() => {
                handleRetryAll();
              }}
            >
              <div className="btnTip">（全部核查对象）</div>
              重试
            </Button>
          </div>
        </div>
      </Modal>
    </Spin>
  );
}
export default TaskDetails;
